export const userDenyGeolocationMessage =
  "Looks like your location settings are blocking us from finding you. To find a store, use the search field above to help us, help you.";

export const USER_COUNTRY = {
  US: "US",
  CA: "CA"
};

export const INVENTORY_TYPE = {
  BOPIS: "bopis",
  STORE: "store"
};

export const locationsAboveMessage = "Locations above don’t float your boat?";

export const noBopisStoresAvailableMessage =
  "Shoot! We're not able to hook you up with Buy Online Pick-Up in Store for this product, but you can grab it in person below:";

export const visitUsMessage =
  "Visit us at a store below to purchase your gear in-person.";

export const MAX_QUANTITY_TO_DISPLAY = 6;

export const noNearbyStoresAvailableMessage = "No results found for";

export const noResultsFoundMessage = "No results found";

export const notAvailableMessage =
  "Darn! Looks like no stores within your selected radius have this gear in-stock. Try your luck by extending the radius or selecting a different product.";
